import { Section } from './section'
import { BodyText, Subheading, Subsection } from './styles'

export const AdditionalDetails = () => {
  return (
    <Section title="Additional details">
      <Subsection>
        <Subheading>A few quick questions about you.</Subheading>
        <BodyText>
          No documents information needed. Just questions about your situation.
        </BodyText>
      </Subsection>
    </Section>
  )
}
